// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"wOP5vbna","messageSuccess":"f8ROQk7q","messageError":"lPV5q2sl","messageInprogress":"_8ZQuVEpo"};